import React from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n-lite';
import { bindActionCreators } from 'redux';
import Logo from '../common/Logo';
import * as accountActions from '../../actions/accountActions';
import routerHistory from '../../routerHistory';
import CustomButton from '../common/CustomButton';
import { ROUTES } from '../../const';

export class Sure extends React.Component {
  constructor(props) {
    super(props);
    this.newPasswordHandler = this.newPasswordHandler.bind(this);
  }

  static propTypes = {};

  componentDidMount() {
    const { accountActions } = this.props;
    accountActions.setIndexTransition(true);
  }

  newPasswordHandler(e) {
    e.preventDefault();
    let email = this.refs.username.value;
    const { accountActions } = this.props;

    if (this.validateEmail(email)) {
      accountActions
        .requestNewPassword(email)
        .then(() => {
          routerHistory.push(ROUTES.LOGIN_SENT);
        })
        .catch(() => {
          routerHistory.push(ROUTES.LOGIN_SURE);
        });
    }
  }

  validateEmail(email) {
    let { accountActions } = this.props;
    let regex = /^.+@.+\..+$/;

    if (!regex.test(email)) {
      accountActions.setFormError(I18n.t('register.emailError'));
      this.refs.username.className = 'error-input';
      return false;
    }
    accountActions.setFormError('');
    this.refs.username.className = '';
    return true;
  }

  formErrorHandler() {
    const { signUp } = this.props;

    return (
      <div className="error expand large-12 small-12 column text-center">
        <span>{signUp.formError}</span>
      </div>
    );
  }

  render() {
    return (
      <div className="column xlarge-6 large-8 medium-10 small-12 content align-center">
        <div className="row box background-color-opaque background-color-opaque-opacity align-center">
          <div className="row small-12 align-top">
            <div className="column">
              <div className="column small-12 text-center">
                <Logo customCss="logo-opaque" />
              </div>
              <h4 className="columns small-12 text-center title">{I18n.t('sure.title')}</h4>
              <p className="columns small-12 text-center error p-32-top-margin">{I18n.t('sure.noAccount')}</p>

              {this.formErrorHandler()}

              <form onSubmit={this.newPasswordHandler}>
                <div className="column xlarge-offset-2 xlarge-8 large-offset-3 large-6 medium-offset-2 medium-8 small-12 error">
                  <input className="error-input" type="email" ref="username" placeholder={I18n.t('sure.yourEmail')} />
                  <CustomButton
                    id="sure-button"
                    className="secondary button expanded"
                    value={I18n.t('common.submit')}
                  />
                </div>
              </form>
            </div>
          </div>

          <div className="row align-self-bottom text-center">
            <Link to={ROUTES.LOGIN}>
              <p className="bottom-link"> {I18n.t('register.backToLogin')} </p>
            </Link>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.account.user,
    signUp: state.signUp,
    i18n: state.i18n
  };
}

function mapDispatchToProps(dispatch) {
  return {
    accountActions: bindActionCreators(accountActions, dispatch),
    dispatch
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Sure);
